import { z } from 'zod';

export const DOStatusName = z.enum([
  '搬入先＆海上A/N金額待ち',
  '支払伝票発行待ち',
  '支払伝票発行済',
  '支払伝票作成待ち',
  '支払伝票作成済',
  '支払伝票送信済',
  '支払伝票入金済',
  'D/O手配済',
  'D/O手配不要',
]);

export type DOStatusName = z.infer<typeof DOStatusName>;

export const DOStatus = z.object({
  name: DOStatusName,
  time: z.string(),
});

export type DOStatus = z.infer<typeof DOStatus>;
